import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { StorageWraperProvider } from './../../providers/storage-wraper/storage-wraper';
import { TokenHelperProvider } from '../../providers/token-helper/token-helper';
import { User } from '../../providers/user/user';
import { CurrentUser } from '../../models/user.model';
import { HomePage } from './../home/home';
import { WebPushProvider } from '../../providers/web-push/web-push';

/**
 * Generated class for the RedirectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: 'redirect/:response',
})
@Component({
  selector: 'page-redirect',
  templateUrl: 'redirect.html',
})
export class RedirectPage {
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storage: StorageWraperProvider,
    public token: TokenHelperProvider,
    public user: User,
    private webPushProvider: WebPushProvider,
    public platform: Platform
  ) {
    var response = this.navParams.get('response');
    console.log('response', response);
    console.log(window.location);
    if (!response) {
      this.navCtrl.push('WelcomePage');
    } else {
      // let tokenDecode = token.decodeToken(response);
      var beforeSet = this.storage.get('user');
      console.log('beforeSet', beforeSet);
      this.storage.set('user', response);
      beforeSet = this.storage.get('user');
      console.log('After', beforeSet);
      this.user
        .getCurrentUser(response)
        .subscribe((currentUser: CurrentUser) => {
          this.storage.set('currentUser', currentUser);
          if ((!document.URL.startsWith('http') || document.URL.startsWith('http://localhost:80')) && !this.platform.is('cordova')) {
            this.webPushProvider.initialiseState();
          }
        });

      this.navCtrl.setRoot('HomePage');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/redirect/redirect.ts